var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,style:(_vm.elementStyles)},[_c('div',{ref:"fixedArea",staticClass:"gc-page-fixed-footer__fixed-area container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }